import type { IxfWatchlistV1OfacMatchKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const OFAC_MATCH_BASE_PATH = getResolvedPath('/clearing/compliance/ofac/match');

export const getOfacMatchPath: EntityPathBuilder<IxfWatchlistV1OfacMatchKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return OFAC_MATCH_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.ofacMatchId) {
        return undefined;
      }

      return getResolvedPath(`${OFAC_MATCH_BASE_PATH}/$ofacMatchId`, context.keys);
    }
  }
};

export function getOfacMatchDetailPath(ofacMatchId: string | undefined) {
  if (!ofacMatchId) {
    return undefined;
  }

  return getOfacMatchPath({ kind: 'detail', keys: { ofacMatchId } });
}
